import React from 'react';
import './SkeletonLoader.css';
const SkeletonLoader = () => {
  return (
    <div className="skeleton-card">
      {/* Image placeholder */}
      <div className="skeleton-shimmer skeleton-img"></div>

      {/* Text + Price placeholder */}
      <div className="skeleton-info">
        <div className="skeleton-shimmer skeleton-line medium"></div>
        <div className="skeleton-shimmer skeleton-line long"></div>
        <div className="skeleton-shimmer skeleton-line short"></div>

        {/* Button placeholder */}
        <div className="skeleton-shimmer skeleton-btn"></div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
